import { useEffect, useState } from "react";
import axios from "axios";
import { useLang } from "../i18n";
import { API } from "../config";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";

export default function Faq() {
  const { t, lang } = useLang();
  const [content, setContent] = useState(null);
  useEffect(() => {
    axios.get(`${API}/content`).then(({ data }) => setContent(data)).catch(() => {});
  }, []);
  const items = content?.faq?.[lang]?.length ? content.faq[lang] : t.faq.items;
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: { "@type": "Answer", text: item.a },
    })),
  };
  return (
    <section id="faq" className="max-w-3xl mx-auto px-6 py-24">
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <p className="eyebrow mb-4">{t.faq.eyebrow}</p>
      <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl tracking-tight font-bold text-topacio-ink mb-12">{t.faq.title}</h2>
      <Accordion type="single" collapsible className="space-y-4">
        {items.map((item, i) => (
          <AccordionItem key={i} value={`faq-${i}`}
            className="card-brutal border-2 px-6 data-[state=open]:shadow-[6px_6px_0_0_#111] data-[state=open]:border-topacio-red transition-shadow">
            <AccordionTrigger data-testid={`faq-trigger-${i}`}
              className="text-left font-display font-bold text-topacio-ink text-sm hover:text-topacio-red hover:no-underline py-5 gap-4">
              <span className="flex items-start gap-4">
                <span className="font-display font-black text-topacio-red/25 text-xl leading-none mt-0.5 shrink-0 w-8">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span>{item.q}</span>
              </span>
            </AccordionTrigger>
            <AccordionContent className="text-sm text-topacio-faded leading-relaxed pb-5 pl-12">
              {item.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
}
